"use client";

import DynamicIcon from "./DynamicIcon";

interface PlatformBadgesProps {
  title: string;
  platforms: {
    name: string;
    icon: string;
  }[];
}

export default function PlatformBadges({ title, platforms }: PlatformBadgesProps) {
  return (
    <section className="py-16 border-b border-border/50 bg-background">
      <div className="container mx-auto px-4 text-center">
        <h3 className="text-lg font-semibold text-muted-foreground mb-8 uppercase tracking-widest">
          {title}
        </h3>

        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-70 hover:opacity-100 transition-opacity duration-300">
          {platforms.map((platform, idx) => (
            <div key={idx} className="flex flex-col items-center gap-2 group">
              <div className="text-4xl md:text-5xl text-foreground/40 group-hover:text-primary transition-colors">
                <DynamicIcon name={platform.icon} />
              </div>
              <span className="text-xs font-medium text-muted-foreground group-hover:text-foreground transition-colors">
                {platform.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
